import { abi } from './abi';
class AudiusToken {
}
AudiusToken.abi = abi;
AudiusToken.address = '0x18aAA7115705e8be94bfFEBDE57Af9BFc265B998';
AudiusToken.types = {
    EIP712Domain: [
        { name: 'name', type: 'string' },
        { name: 'version', type: 'string' },
        { name: 'chainId', type: 'uint256' },
        { name: 'verifyingContract', type: 'address' }
    ],
    Permit: [
        { name: 'owner', type: 'address' },
        { name: 'spender', type: 'address' },
        { name: 'value', type: 'uint256' },
        { name: 'nonce', type: 'uint256' },
        { name: 'deadline', type: 'uint256' }
    ]
};
export { AudiusToken };
//# sourceMappingURL=audiusToken.js.map